import React from "react";
import SimpleModal from "../../../SimpleModal";
import { FaExclamationTriangle } from "react-icons/fa";
import "./index.css";
import Util from "../../../../global/utils/Helpers";
import { withRouter } from "react-router-dom";
import { cleanData } from "../../../Forms/Form9142A/helpers";
import { cleanDataV2 } from "../../../Forms/Form9142AV2/helpers";
import renderStatusModal from "../../../Forms/renderStatusModal";
import "../../StatusModal/modal.css";

import { fetchLinkingCaseData } from "../../CaseReuse/helpers";
import mappingSchema from "./mapping/mappingSchema";
import { convertMappedValue } from "./mapping/utils";

export function AcknowledgeModal({
  updateJOLinking,
  acknowledgeCancel,
  acknowledgeModal,
  handleAcknowledgeClick,
  setAcknowledgeModal,
  owner,
  isV2,
  setIsLinking,
  currentSelectedCase,
  selectedCase,
  setSelectedCase,
  handleRemove,
  makeMetaDataUpdates,
  linkedFormVersionId,
  setLinkedFormVersionId,
  application_id,
  formApi,
  formValues,
  form_ui,
  input,
}) {
  const handleUpdate = async (
    formApi,
    dataprop_name,
    updateJOLinking,
    application_id,
    values,
    form_ui,
    form_ui_name,
    cleanData,
    data,
    caseNum
  ) => {
    delete form_ui.__typename;
    let newData = { ...values, formVersionId: linkedFormVersionId };

    if (selectedCase) {
      newData.e3_is_job_order_complete = selectedCase;
    }

    let updatedJO = await updateJOLinking({
      variables: {
        id: application_id,
        [dataprop_name]: cleanData(newData),
        [form_ui_name]: form_ui,
        Form790LookupUpdateInput: {
          LinkedForm9142ANumber: application_id,
          caseOwner: owner,
          caseNumberFor790A: selectedCase,
          islinked: true,
        },
      },
      actionType: "add", // Pass the action type to track the operation
    });

    if (updatedJO?.data && !updatedJO.errors) {
      formApi.change("e3_is_job_order_complete", selectedCase);
      !isV2 && makeMetaDataUpdates(formApi, data);
      if (typeof data?.form_version_id === "number") {
        setLinkedFormVersionId(data?.formVersionId);
      }
      setSelectedCase(caseNum);
    } else {
      formApi.change("e3_is_job_order_complete", null);
      setSelectedCase(undefined);
    }

    setIsLinking(false);
  };

  const fetchCaseData = async (
    caseNum,
    formApi,
    dataprop_name,
    updateJOLinking,
    application_id,
    values,
    form_ui,
    form_ui_name,
    formId
  ) => {
    setIsLinking(true);
    fetchLinkingCaseData(caseNum, formId)
      .then((data) => {
        if (data) {
          data = data?.data?.getDatahubCase;
          handleUpdate(
            formApi,
            dataprop_name,
            updateJOLinking,
            application_id,
            values,
            form_ui,
            form_ui_name,
            isV2 ? cleanDataV2 : cleanData,
            data,
            caseNum
          );

          makeFieldUpdates(data, formApi, formId);
        }
      })
      .catch((err) => console.error(err));
  };

  const makeFieldUpdates = (values, formApi, formId) => {
    if (values) {
      mappingSchema?.[formId].forEach(({ from, to, type, defaultValue }) => {
        const mappedValue =
          defaultValue || convertMappedValue(values[from], type);
        if (mappedValue) {
          formApi.change(to, mappedValue);
        }
      });
    }
  };

  const checkIfLinked = async (jo_number) => {
    let query = `query{isLinked790(case_number:"${jo_number}")}`;
    let result = await Util.handleGraphql(query);
    if (result) {
      return result.data.isLinked790;
    } else {
      throw Error("Could not determine if case is linked.");
    }
  };

  return (
    <SimpleModal
      toggleModal={(e) => handleAcknowledgeClick(e)}
      modalStatus={acknowledgeModal}
      renderButton={() => null}
    >
      <div className={"acknowledge-modal"}>
        <div className={"acknowledge-modal-icon"}>
          <FaExclamationTriangle size={80} color={"#005ea2"} />
        </div>
        <div className={"acknowledge-modal-text"}>
          <p>
            <b>
              Changing field values from your 790A may impact processing of this
              application
            </b>
          </p>
          <div>
            <button
              type={"button"}
              className={"usa-button usa-button-alert"}
              onClick={(e) => acknowledgeCancel(e)}
            >
              Cancel
            </button>
            <button
              type={"button"}
              className={"usa-button usa-button-primary"}
              onClick={async (e) => {
                try {
                  if (
                    currentSelectedCase &&
                    currentSelectedCase !== selectedCase
                  ) {
                    // updateJOLinking rather than updateForm790Lookup because if filer selects a new case that's already linked, it will remove from lookup but when they refresh, the 9142A will say it's still linked.
                    await handleRemove(
                      undefined,
                      formApi,
                      updateJOLinking,
                      application_id,
                      input.value,
                      true
                    );
                  }

                  const isLinked = await checkIfLinked(selectedCase);

                  if (isLinked) {
                    renderStatusModal(
                      false,
                      "Selected case is already linked."
                    );
                  } else {
                    await fetchCaseData(
                      selectedCase,
                      formApi,
                      isV2 ? "Form9142AFormDataV2" : "Form9142AFormData",
                      updateJOLinking,
                      application_id,
                      formValues,
                      form_ui,
                      "formUI9142A",
                      "9142A"
                    );
                  }
                  setAcknowledgeModal(!acknowledgeModal);
                } catch (err) {
                  console.error(err);
                }
              }}
            >
              Acknowledge
            </button>
          </div>
        </div>
      </div>
    </SimpleModal>
  );
}

export default withRouter(AcknowledgeModal);
